import { useDialog } from '@globals/dialog/useDialogStore'
import theme, { colors } from '@globals/themes/defaultTheme'
import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import Typography from '@mui/material/Typography'
import { SxProps } from '@mui/material/styles'
import { FC, ReactNode } from 'react'
import { DialogCloseButton } from './Dialog.styled'

export const drawerPaperStyles: SxProps = {
  zIndex: theme.zIndex.drawer + 1,
  '& .MuiDrawer-paper': {
    borderRadius: '16px 16px 0 0',
    maxHeight: 'calc(100vh - 80px)', // prevents the user from not being able to click outside to close
  },
}

export const ModalProps = {
  // Fix accessibility issue with aria-hidden on backdrop
  BackdropProps: {
    // Ensure backdrop doesn't interfere with focus management
    'aria-hidden': undefined,
  },
  // Ensure proper focus management
  disablePortal: false,
  disableScrollLock: true,
}

type BottomDrawerProps = {
  drawerKey: string
  children: ReactNode
  onClose?: () => void
  title?: ReactNode
  drawerStyles?: SxProps
  hasActions?: boolean
  backgroundColor?: string
}

const BottomDrawer: FC<BottomDrawerProps> = ({
  drawerKey,
  children,
  onClose,
  title,
  hasActions = false,
  drawerStyles,
  backgroundColor = colors.whiteDark,
}) => {
  const { closeDialog, isOpen } = useDialog(drawerKey)

  const handleOnClose = () => {
    if (onClose) {
      onClose()
    }
    closeDialog()
  }

  const bottomMargin = (): number => {
    return hasActions ? 10 : 0
  }

  return (
    <Drawer
      anchor="bottom"
      variant="temporary"
      open={isOpen}
      onClose={closeDialog}
      sx={{ ...drawerStyles, ...drawerPaperStyles }}
      ModalProps={ModalProps}>
      <DialogCloseButton id={`${drawerKey}-close`} onClose={handleOnClose} />
      {!!title && (
        <Box sx={{ p: 2, width: '95%' }}>
          <Typography variant="h3" mt={{ xs: 0, sm: 0 }} textAlign="center">
            {title}
          </Typography>
        </Box>
      )}
      <Box px={2} pt={title ? 0 : 6} pb={2} mb={bottomMargin()} sx={{ backgroundColor }}>
        {children}
      </Box>
    </Drawer>
  )
}

export default BottomDrawer
